import { type Qualification } from "@clipboard-health/contract-worker-app-bff";
import { ToggleButton } from "@src/appV2/redesign/system/ui-components";

import { FiltersToggleButtonGroup } from "./BottomSheet/ToggleButtonGroup";
import { type FiltersFormValues } from "./BottomSheet/types";
import { FILTER_ALL_VALUE, useFilterSelectedOptions } from "./BottomSheet/useFilterSelectedOptions";

interface QualificationsFilterButtonGroupProps {
  value?: FiltersFormValues["licenses"];
  onChange: (value: FiltersFormValues["licenses"]) => void;
  qualifications: Qualification[];
  showAllButton?: boolean;
}

export function QualificationsFilterButtonGroup(props: QualificationsFilterButtonGroupProps) {
  const { value, onChange, qualifications, showAllButton = true } = props;
  const availableQualificationNames = qualifications.map(
    (qualification) => qualification.attributes.name
  );

  const { selectedOptions, onChangeSelection } = useFilterSelectedOptions(
    value ?? [],
    onChange,
    availableQualificationNames
  );

  // Safety check to avoid showing an empty filter, likely never to happen.
  if (availableQualificationNames.length === 0) {
    return null;
  }

  const isSelected = (qualification: Qualification) =>
    selectedOptions.includes(qualification.attributes.name) ||
    selectedOptions.includes(FILTER_ALL_VALUE);

  return (
    <FiltersToggleButtonGroup
      value={selectedOptions}
      aria-label="Shift Licenses Filter Toggle Buttons"
      onChange={(newValue) => {
        onChangeSelection(newValue ?? []);
      }}
    >
      {showAllButton && <ToggleButton value={FILTER_ALL_VALUE}>All</ToggleButton>}
      {qualifications.map((qualification) => (
        <ToggleButton
          key={qualification.attributes.name}
          value={qualification.attributes.name}
          selected={isSelected(qualification)}
          iconType={isSelected(qualification) ? "checkmark" : undefined}
        >
          {qualification.attributes.displayLabel}
        </ToggleButton>
      ))}
    </FiltersToggleButtonGroup>
  );
}
